export default __webpack_public_path__ + "static/bg-what-is-ml--mobile-3c9eb96f6addadf83970ccbfde6fd238.jpg";